import { render, staticRenderFns } from "./AddFundsModal.vue?vue&type=template&id=253e13cc&"
import script from "./AddFundsModal.vue?vue&type=script&lang=js&"
export * from "./AddFundsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports